// Spec #34 / #99: the web client persists the access + refresh tokens in
// `sessionStorage` (per the user's selection). `sessionStorage` is
// per-tab, so a new tab asks the user to sign in again — same isolation
// guarantee as `flutter_secure_storage` on a fresh app install.
import type { AuthSession } from './types';

const STORAGE_KEY = 'fieldreport.auth.session.v1';

export function readStoredSession(): AuthSession | null {
  if (typeof window === 'undefined') return null;
  const raw = window.sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as AuthSession;
    if (!parsed.accessToken || !parsed.refreshToken) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeStoredSession(session: AuthSession): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
}

export function clearStoredSession(): void {
  if (typeof window === 'undefined') return;
  window.sessionStorage.removeItem(STORAGE_KEY);
}
